// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-shopping-bag-icon[data-v-aa858f2c]{display:inline-block;width:1em;height:1em;fill:currentColor;vertical-align:-.125em}.c-shopping-bag-icon path[data-v-aa858f2c]{color:inherit}", ""]);
// Exports
module.exports = exports;
